<c-form-field [control]="control" [showErrors]="showError">
  @if (label) {
    <ion-label class="textarea__label">{{ label | transloco }}</ion-label>
  }

  <div class="textarea__box" cFieldBox>
    <ion-textarea
      class="textarea__field"
      [rows]="rows"
      [cols]="cols"
      placeholder="{{ placeholder | transloco }}"
      [formControl]="control"
      [maxlength]="maxLength"
      [autoGrow]="autoGrow"
      [counter]="counter"
      mode="ios"
    ></ion-textarea>
  </div>

  <c-field-message [helpText]="helpText" />
</c-form-field>
